import moment from 'moment-jalaali'

export const jalaaliYear = (date) => {
  if (date) return moment(date).format('jYYYY')
  return date
}

export const jalaaliWeekDayName = (date) => {
  if (date) return moment(date).locale('fa').format('dddd')
  return date
}

export const jalaaliDayOfMonth = (date) => {
  if (date) return moment(date).locale('fa').format('jD')
  return date
}

export const jalaaliMonthName = (date) => {
  if (date) return moment(date).locale('fa').format('jMMMM')
  return date
}

export const jalaaliFullDate = (date) => {
  if (date) return moment(date).format('jYYYY/jMM/jDD')
}

export const jalaaliTime = (date) => {
  if (date) return moment(date).format('HH:mm')
  return date
}

export const ssToHhMm = (second) => {
  if (second === null || second === '') return null

  second = Number(second)

  const minutes = Math.floor(second / 60)
  second = second % 60
  return {
    hour: Math.floor(minutes / 60) || null,
    minutes: minutes % 60 || null
  }
}

export const convertToDateTimeZone = (date, time) => {
  const miladiFullDate = moment(`${date} ${time}`, 'jYYYY/jM/jD HH:mm').format(
    'YYYY/MM/DD HH:mm:ss'
  )
  return moment(miladiFullDate).utc().format()
}

export const dateToUTC = (date) => {
  const miladiFullDate = moment(`${date}`, 'YYYY/M/D').format(
    'YYYY/MM/DD HH:mm:ss'
  )
  return moment(miladiFullDate).utc().format()
}

export const currentDateTimeZone = () => {
  const now = moment().format('YYYY/MM/DD HH:mm:ss')

  return moment(now).utc().format()
}
